/** Blizzard (fx 'blizzard'): a storm of snow round the caster, or crashing down on the spot picked. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('blizzard', (host) => ({
  skill: ({ src, s, sx, sy, tx, ty, spot }) => {
    const r = (s.aoe ?? 2.5) * 20;
    // Around the caster, or (ground-targeted) the storm crashing down on the picked spot.
    const [bx, by] = spot ? [tx, ty] : [sx, sy];
    host.swingArc(src, spot ? 'overhead' : 'spin', '230,245,255', 1.4);
    host.fx.push({ type: 'ring', x: bx, y: by, t: 0, life: 0.6, r: r * 1.2, col: '210,235,255' });
    host.fx.push({ type: 'sigil', x: bx, y: by, t: 0, life: 0.9, r, col: '200,230,255' });
    if (spot) {
      host.fx.push({ type: 'beam', x: bx, y: by, t: 0, life: 0.5, w: r * 0.6, col: '200,235,255' });
      host.fx.push({ type: 'shock', x: bx, y: by, t: 0.05, life: 0.5, r: r * 1.1, col: '220,240,255' });
      // Snow and ice shards pouring out of the sky onto the circle.
      for (let k = 0; k < 36; k++) {
        const a = R() * Math.PI * 2;
        const d = Math.sqrt(R()) * r;
        host.parts.push({
          x: bx + Math.cos(a) * d - 30,
          y: by + Math.sin(a) * d * 0.5 - 90 - R() * 70,
          vx: 80,
          vy: 220 + R() * 80,
          g: 0,
          t: 0,
          life: 0.45,
          c: R() < 0.5 ? '#ffffff' : '#bfe4ff',
          streak: true,
        });
      }
    }
    for (let k = 0; k < 40; k++) {
      const a = R() * Math.PI * 2;
      const d = R() * r;
      host.parts.push({
        x: bx + Math.cos(a) * d,
        y: by + Math.sin(a) * d * 0.5 - R() * 30,
        vx: -Math.sin(a) * 60,
        vy: Math.cos(a) * 30 + 10,
        g: 15,
        t: 0,
        life: 0.7 + R() * 0.4,
        c: R() < 0.6 ? '#ffffff' : '#bfe4ff',
        s: R() < 0.3 ? 2 : 1,
        drag: 1,
      });
    }
    host.sfx.swing();
  },
}));
